class Saetze {

    /**
     * Allgemeine Sätze
     *
     */

    //Krankenkasse 109€, 189€ ü 30
    static get krankenversicherungjung() {return 102;}
    static get krankenversicherung30() {return 185;}
    static get pflegeversicherungjung() {return 35;}
    static get pflegeversicherung30() {return 48;}

    //kinderbetreungszuschlag
    static get kinderbetreuungbafog() {return 160;}
    static get kinderbetreuungmeister() {return 160;}

    static get FREIBETRAG_KIND() {return 770;} // 570 ->2020; 605 -> 2021
    static get FREIBETRAG_VERMOEGEN_KIND() {return 2300;}
    static get FREIBETRAG_EINNAHMEN_KIND() {return 140;}
    static get FREIBETRAG_VERMOEGEN_EHEPARTNER() {return 2300;}
    static get FREIBETRAG_VERMOEGEN_AUFSTIEG() {return 45000;}
    static get FREIBETRAG_VERMOEGEN_BAFOEG() {return 15000;}
    static get FREIBETRAG_VERMOEGEN_BAFOEGAB30() {return 45000;}

    static get FREIBETRAG_EHEPARTNER_EINKOMMEN() {return 1605;} // wie eltern unverheiratet
    static get FREIBETRAG_EHEPARTNER_STIEF() {return 805;} // 630 ->2020; 665 -> 2021
    static get FREIBETRAG_EINKOMMEN_STUDENTSELBST() {return 353;}
    static get FREIBETRAG_EINKOMMEN_VERHEIRATET() {return 850;}
    static get FREIBETRAG_KOSTEN_AUSBILDUNG() {return 370;} //305 ->2021
    static get FREIBETRAG_VERMOEGEN_RIESTER() {return 1925;} //Freibetrag Riester 1925€
    static get FREIBETRAG_ELTERNEINKOMMEN_VERHEIRATET() {return 2540;} //1890 ->2020; 2000 -> 2021
    static get FREIBETRAG_ELTERNEINKOMMEN_UNVERHEIRATET() {return 1690;} //1260 ->2020 1330 -> 2021

    static get SOZIAL_RENTNER() {return 0.165;}
    static get SOZIAL_RENTNER_GRENZE() {return 10200;}
    static get SOZIAL_PAUSCHALE() {return 0.223;}
    static get SOZIAL_PAUSCHALE_UMG() {return 0.777;}
    static get SOZIAL_GRENZE() {return 17200;}
    static get SOZIAL_SELBSTST() {return 0.388;}
    static get SOZIAL_SELBSTST_GRENZE() {return 29500;}

    static get WERBUNGSKOSTEN() {return 1230;}
    static get KINDERALTERBIS() {return 14;}
    static get MAX_AUSLAND_STUD_GEBUEHREN() {return 5600;}

    static get FREIBETRAG_WAISE_STUDI() {return 190;}
    static get FREIBETRAG_WAISE_SCHUELERMIT() {return 190;} // mit Ausbildung
    static get FREIBETRAG_WAISE_SCHUELEROHNE() {return 270;} // Ohne Ausbildung

    static get MEISTER_STUECK() {return 2000;} // bis zu 2000 € für Meisterstück
    static get MEISTER_STUECK_ANTEIL() {return 50;} // Anteilig maximal 50%
    static get MEISTER_GEBUEHR() {return 15000;} // bis zu 15000 € für Lehrgangs- und Prüfungsgebühren
    static get MEISTER_GEBUEHR_ANTEIL() {return 50;} // Anteilig maximal 50%, Rest als Darlehen


    static get saetze() {
        return {
            b: { //Hochschule allein
                grundbedarf: 475,
                wohnzuschuss: 380,
                kinderbetreungszuschlag: Saetze.kinderbetreuungbafog
            },
            //Hochschule bei eltern
            c: {
                grundbedarf: 475,
                wohnzuschuss: 59,
                kinderbetreungszuschlag: Saetze.kinderbetreuungbafog
            },
            //allg Schule ab 10. Klasse, FOS, Berufsfachschule,
            // keine Ausbildung vorausgesetzt
            d: {
                grundbedarf: 0,
                wohnzuschuss: 666,
                kinderbetreungszuschlag: Saetze.kinderbetreuungbafog
            },
            //Abendhaupt- und Abendrealschulen, Berufsaufbauschulen, Fachoberschulklassen,
            // Ausbildung vorausgesetzt
            e: {
                grundbedarf: 498,
                wohnzuschuss: 277,
                kinderbetreungszuschlag: Saetze.kinderbetreuungbafog
            },
            //Berufsfachschul- und Fachschulklassen, die in einem zumindest zweijährigen Bildungsgang einen berufsqualifizierenden Abschluss vermitteln, 
            //keine Ausbildung vorausgesetzt
            f: {
                grundbedarf: 276,
                wohnzuschuss: 390,
                kinderbetreungszuschlag: Saetze.kinderbetreuungbafog
            },
            //Fachschulklassen, Abendgymnasium,  Kolleg
            //Ausbildung vorausgesetzt
            g: {
                grundbedarf: 501,
                wohnzuschuss: 321,
                kinderbetreungszuschlag: Saetze.kinderbetreuungbafog
            },
            aufstiegsbafoeg: {
                selbst: 841,
                wohnzuschuss: 0,
                ehepartner: 235,
                kindergeld: 235,
                kinderbetreungszuschlag: Saetze.kinderbetreuungmeister
            }
        }
    }

}
module.exports = Saetze;
